import { useState } from 'react'
import { ArrayParam, StringParam, useQueryParams } from 'use-query-params'

import { useQueryList } from '@percent/utility'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { StandaloneFormQuestion } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'
import { QuestionsTable } from './questionsTable/QuestionsTable'
import { AddQuestionModal } from './addQuestionModal/AddQuestionModal'
import { EditQuestionModal } from './editQuestionModal/EditQuestionModal'

const QUESTIONS_PAGE_SIZE = 25

export function QuestionsContainer() {
  const { grantProgramService } = useServices()
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)
  const [editingQuestion, setEditingQuestion] = useState<StandaloneFormQuestion | null>(null)

  const [queryParams, setQueryParams] = useQueryParams({
    partnerId: StringParam,
    search: StringParam,
    questionIds: ArrayParam
  })

  const questionIds = queryParams.questionIds?.filter((id): id is string => id != null) ?? []

  const [{ totalResults, isLoading, data }, { nextPage, previousPage, refresh }] = useQueryList(
    ['/v1/admin/grants/questions', queryParams.partnerId, queryParams.search, questionIds],
    grantProgramService.getStandaloneFormQuestions,
    {
      pageSize: QUESTIONS_PAGE_SIZE,
      partnerId: queryParams.partnerId ?? undefined,
      search: queryParams.search ?? undefined,
      questionIds: questionIds.length > 0 ? questionIds : undefined
    }
  )

  return (
    <>
      <QuestionsTable
        data={data ?? []}
        totalResults={totalResults}
        isLoading={isLoading}
        nextPage={nextPage}
        previousPage={previousPage}
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        onAddQuestion={() => setIsAddModalOpen(true)}
        onEditQuestion={setEditingQuestion}
      />
      <AddQuestionModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} refresh={refresh} />
      <EditQuestionModal question={editingQuestion} onClose={() => setEditingQuestion(null)} refresh={refresh} />
    </>
  )
}
